import type { OfflineDraftRecord } from "../types/requisition";

function safeFileSegment(value: string): string {
  return value.trim().replace(/[^a-z0-9_-]+/gi, "_").replace(/^_+|_+$/g, "") || "requisition";
}

function buildHeaderRows(draft: OfflineDraftRecord): Array<[string, string | number | null]> {
  return [
    ["Local Draft ID", draft.localDraftId],
    ["Server Requisition ID", draft.serverRequisitionId],
    ["Vessel ID", draft.vesselId],
    ["Author User ID", draft.authorUserId],
    ["Origin", draft.origin],
    ["Department", draft.department],
    ["Type", draft.reqType],
    ["Priority", draft.priority],
    ["Category Account Code ID", draft.category_account_code_id ?? null],
    ["Status", draft.status],
    ["Created At", draft.createdAt],
    ["Updated At", draft.updatedAt],
    ["Order Purpose", draft.purpose],
  ];
}

function buildLineRows(draft: OfflineDraftRecord) {
  return draft.items.map((item, index) => ({
    "Line No": index + 1,
    "Item ID": item.item_id ?? "",
    "Component ID": item.component_id ?? "",
    "Service Type ID": item.service_type_id ?? "",
    Description: item.item_name,
    "Part No": item.part_no ?? "",
    "Drawing No": item.drawing_no ?? "",
    "IMPA Code": item.impa_code ?? "",
    Specification: "",
    Maker: "",
    Unit: item.unit,
    "Requested Qty": item.requested_qty,
    "Current ROB": item.current_rob ?? "",
    "Min Qty": item.min_qty ?? "",
    "Max Qty": item.max_qty ?? "",
    Critical: item.is_critical === true ? "YES" : item.is_critical === false ? "NO" : "",
    Remark: item.item_remark ?? "",
  }));
}

export async function exportOfflineDraftToExcel(draft: OfflineDraftRecord): Promise<void> {
  const xlsx = await import("xlsx");
  const workbook = xlsx.utils.book_new();
  const headerSheet = xlsx.utils.aoa_to_sheet([
    ["Emergency Offline Requisition Export"],
    ["This requisition was exported offline. Please create it in the system on behalf of the vessel."],
    [],
    ...buildHeaderRows(draft),
  ]);
  const lineSheet = xlsx.utils.json_to_sheet(buildLineRows(draft));

  xlsx.utils.book_append_sheet(workbook, headerSheet, "Header");
  xlsx.utils.book_append_sheet(workbook, lineSheet, "Line Items");

  const fileName = `EMERGENCY_REQ_${safeFileSegment(String(draft.vesselId))}_${safeFileSegment(
    draft.localDraftId,
  )}.xlsx`;
  xlsx.writeFile(workbook, fileName, { compression: true });
}
